import React, { useState, useEffect, useCallback } from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';

import AdminHeader from './AdminHeader';
import QuizApi from '../QuizApi';

export default function AdminSuperOrganizationDetail({ organizationId }) {

  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState(null);
  const [error, setError] = useState(null);

  const [upgradingUserId, setUpgradingUserId] = useState(null);
  const [upgradeError, setUpgradeError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await QuizApi.superOrganizationDetailsGet(organizationId);
      if (!result.success) throw new Error(result.error || 'Fel vid hämtning');
      setSettings(result.response);
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  }, [organizationId]);

  useEffect(() => { load(); }, [load]);

  const upgradeUser = useCallback(async (userRandom) => {
    if (!window.confirm('Uppgradera den här användaren till Premium?')) return;
    setUpgradingUserId(userRandom);
    setUpgradeError(null);
    const result = await QuizApi.superOrganizationUserSetPremium(organizationId, userRandom);
    setUpgradingUserId(null);
    if (result.success) {
      load();
    } else {
      setUpgradeError(result.error || 'Kunde inte uppgradera användaren.');
    }
  }, [organizationId, load]);

  return (
    <div id="adminSuperOrganizationDetail">
      <AdminHeader />
      <div className="adminContentWrapper">

        <Button
          variant="outline-secondary"
          size="sm"
          className="mb-3"
          onClick={() => window.history.back()}>
          Tillbaka
        </Button>

        {loading && <Spinner animation="border" />}
        {error && <Alert variant="danger">{error}</Alert>}

        {!loading && settings && (
          <>
            <h5 className="mb-4">{settings.orgName}</h5>

            {upgradeError && <Alert variant="danger">{upgradeError}</Alert>}

            <div className="adminTableScroll" style={{ maxWidth: '640px' }}>
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Användarnamn</th>
                    <th>Namn</th>
                    <th>E-post</th>
                    <th>Nivå</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {settings.userList.map(u => (
                    <tr key={u.id}>
                      <td>{u.name}</td>
                      <td>{u.fullName || <span className="text-muted">—</span>}</td>
                      <td>{u.email || <span className="text-muted">—</span>}</td>
                      <td>
                        {u.isFreeTier
                          ? <span className="badge badge-warning">Gratis</span>
                          : <span className="badge badge-success">Premium</span>}
                      </td>
                      <td>
                        {u.isFreeTier && (
                          <Button
                            size="sm"
                            className="btn-quizPrimaryDark"
                            disabled={upgradingUserId === u.id}
                            onClick={() => upgradeUser(u.id)}>
                            {upgradingUserId === u.id ? <Spinner animation="border" size="sm" /> : 'Uppgradera till Premium'}
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                  {settings.userList.length === 0 && (
                    <tr><td colSpan={5} className="text-muted">Inga användare.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
